import { BookmakerName } from '@/constants';
import { formatOdds } from '@/helpers/common';

export function timeUntilEventKickoff(leftMinutes: number) {
    const { t } = useI18n();
    let diff = '-';

    if (leftMinutes < 1) {
        diff = t('common.live');
    } else {
        const days = Math.floor(leftMinutes / (60 * 24));
        const hours = Math.floor((leftMinutes % (60 * 24)) / 60);
        const minutes = Math.floor((leftMinutes % (60 * 24)) % 60);

        if (days) diff += `${days}d `;
        if (hours) diff += `${hours}h `;
        if (minutes) diff += `${minutes}m `;
    }

    return diff;
}

export function oddsTooltip(priceList: [number, number][], withValues = true, siteIdIdx = 0, priceIdx = 1) {
    let qtip = '';
    let precision = 3;

    if (priceList) {
        priceList.forEach(function (data) {
            qtip += '<span style="width: 75px;display: inline-block;">' + BookmakerName[data[siteIdIdx]] + '</span>';
            qtip += withValues ? ' ' + formatOdds(data[priceIdx], precision) + '<br>' : '<br>';
        });
    }

    return qtip;
}

export function parseCustomEventId(customEventId: string): [string, number, number] {
    const awayCustomTeamId = parseInt(customEventId.slice(-7));
    const homeCustomTeamId = parseInt(customEventId.slice(-14, -7));

    const year = customEventId.slice(-16, -14);
    const day = customEventId.slice(-18, -16);
    const month = customEventId.slice(0, -18);

    const date = `20${year}-${month.padStart(2, '0')}-${day}`;

    return [date, homeCustomTeamId, awayCustomTeamId];
}
